import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";
import "./errorPage.css";

class NotFound extends Component {

   componentDidMount(){
    document.querySelector('body').classList.add('notfound_page');
    document.querySelector('body').classList.remove('login_page');

   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
      <div className="container">
      <div className="row">
          <div className="col-lg-12">
              &nbsp;
              <a href="/" className="login_logo"><img width="100px" src="/assets/images/logi_logo.png" /></a>
          </div>
        <div className="col-lg-12 text-center notfound_msg">
            
            <div className="notfound_div">{languagelist.notf1}</div>
            <div className="notfound_head">{languagelist.notf2}</div>
            <button className="notfound_btn" onClick={this.backButton.bind(this)}>{languagelist.notf3}</button>
        </div>
        </div>
        </div>
      );
    }
  }
export default NotFound;